import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import _ from 'lodash';

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        return { ...state, ...action.payload.entities.diagnosis };
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.patientsContainer.entities) {
            return { ...state, ...action.payload.patientsContainer.entities.diagnosis };
        } else {
            return state;
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.addDiagSuccess]: (state, action) => {
        let val = _.merge(state, action.payload.entities.diagnosis);
        return val;
    },
    [patientActions.removeDiagSuccess]: (state, action) => {
        let newState = state;
        Object.values(newState).forEach(x => {
            if (x.epno === action.payload.epno) {
                delete newState[x.id];
            }
        });
        let val = _.merge(newState, action.payload.diags.entities.diagnosis);
        return val;
    },
    [patientActions.copyAllDiagSuccess]: (state, action) => {
        let val = _.merge(state, action.payload.entities.diagnosis);
        return val;
    },
    [patientActions.updateDiagOnsetSuccess]: (state, action) => {
        let val = _.merge(state, action.payload.entities.diagnosis);
        return val;
    },

})


